
import plane from '../../polyMesh/geometric/primitives/Plane';

const Plane = {
  schema: {
    width: { label: 'Width', type: 'Number', defaultValue: 4, minValue: 0.0, step: 0.1, animatable: true },
    height: { label: 'Height', type: 'Number', defaultValue: 4, minValue: 0.0, step: 0.1, animatable: true },
    widthSegments: { type: 'Number', label: 'Width Segments', defaultValue: 1, minValue: 1, isInteger: true, animatable: true },
    heightSegments: { type: 'Number', label: 'Height Segments', defaultValue: 1, minValue: 1, isInteger: true, animatable: true },
  },

  update: function (operator, primitive) {
    const { width, height, widthSegments, heightSegments } = operator;
    primitive.mesh = plane(width, height, widthSegments, heightSegments);
  },
};

export default Plane;




// WEBPACK FOOTER //
// ./src/operators/PolyMesh/Plane.js